<template>
  <div class="modal d-block" v-if="show">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title fw-bold">{{ title }}</h4>
        </div>
        <div class="modal-body">{{ message }}</div>
        <div class="modal-footer">
          <a class="btn procricket-btn text-white" role="button" @click="$emit('close')">OK</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Success"
    },
    message: {
      type: String,
      default: ""
    }
  },
  emits: ["close"]
}
</script>
